import React from "react"
import QueueAnim from "rc-queue-anim"
import TweenOne from "rc-tween-one"
import { get } from "lodash"
import { Image, Flex, Box } from "rebass"
import { TextAnimation, defaultSubtitle, defaultTitle } from "./Text"

const RightImageElement = (props) => {
  const { data, id, matches } = props
  const marginLeftText = get(data, "position.marginLeftText", "-100px")
  const isAnimation = get(data, "image.isAnimation", false)
  const animationImage = isAnimation
    ? {
        type: get(data, "image.animation.type", "from"),
        ease: get(data, "image.animation.ease", "easeInQuart"),
        opacity: get(data, "image.animation.opacity", 0),
        delay: get(data, "image.animation.delay", 40),
        duration: get(data, "image.animation.duration", 1500),
      }
    : {}

  const useMobile = matches
    ? get(
        data,
        "url_image_mobile",
        get(
          data,
          "url_image",
          "https://via.placeholder.com/400x400?text=400x400=CMS"
        )
      )
    : get(
        data,
        "url_image",
        "https://via.placeholder.com/480x480?text=480x480=CMS"
      )

  const title = get(data, "title", defaultTitle)
  const subtitle = get(data, "subtitle", defaultSubtitle)

  return (
    <Box w={[1]}>
      <QueueAnim name={`Queue-${data.name}-${id}`}>
        <Flex w={[1]} align={"center"}>
          <Flex
            w={[1]}
            direction={["column-reverse", "column-reverse", "row"]}
            align={"center"}
          >
            <Flex
              w={[1]}
              direction={"column"}
              marginLeft={["0px", "0px", marginLeftText]}
              style={{ zIndex: 9 }}
            >
              <TextAnimation data={title} />
              <TextAnimation data={subtitle} />
            </Flex>
            <TweenOne
              animation={animationImage}
              name={`TweenOne-image-right-${data.name}-${id}`}
            >
              <Image src={useMobile} />
            </TweenOne>
          </Flex>
        </Flex>
      </QueueAnim>
    </Box>
  )
}

export default RightImageElement



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/carouselAnimation/RightImageElement.js